<template>
  <div class="salesList">
    <table id="table" border="0" cellpadding="0" cellspacing="0" style="width:100%">
      <caption id="tablePrintText">
        <div style="font-weight:600;letter-spacing:0px">{{hotelInfo.name}}</div>
        <div style="font-weight:600;font-size:28px">菜品销售榜</div>
        <div style="display: flex;justify-content:center; width:100%;margin:10px 0 10px 0">
          <div style="margin:0 20px">
            <span style="font-weight:600">营业日期:{{listQuery.startTime}} 至 {{listQuery.endTime}}</span>
          </div>
          <div style="">
            <span style="font-weight:600;margin:0 20px">收银员:{{employee.name}}</span>
            <span style="font-weight:600;margin:0 20px">班次:{{employee.name}}</span>
            <span style="font-weight:600;margin:0 20px">打印时间:{{currentTime}}</span>
          </div>
        </div>
      <!--   <div style="display:flex;justify-content:flex-start;margin:0 0 7px 20px;color:#0099ff;font-size:24px">
          销售
        </div> -->
      </caption>

      <thead style="">
        <tr>
          <th v-for="(item,index) in nameTitle" :key="index" @click="handleSort(item.key)" style="position:sticky;top:-21px;background-color:#fff;border-top:1px solid #eaeaea;border-bottom:1px solid #eaeaea;line-height:66px;font-size:24px">{{item.name}}</th>
 
        </tr>
      </thead>
      <tbody>
        <tr v-for="tr in list" :key="tr.code">
          <td align="center">{{tr.outletName}}</td>
          <td align="center">{{tr.bookName}}</td>
          <td align="center">{{tr.typeCode}}</td>
          <td align="center">{{tr.typeName}}</td>
          <td align="center">{{tr.dishesCode}}</td>
          <td align="center">{{tr.food_name}}</td>
          <td align="center">{{tr.quantity}}</td>
          <td align="center">{{tr.price?tr.price.toFixed(2):'0.00'}}</td>
          <td align="center">{{tr.discount?tr.discount.toFixed(2):'0.00'}}</td>
          <td align="center">{{tr.tax?tr.tax.toFixed(2):'0.00'}}</td>
          <td align="center">{{tr.server_price?tr.server_price.toFixed(2):'0.00'}}</td>
          <td align="center">{{tr.discount_price?tr.discount_price.toFixed(2):'0.00'}}</td>
          <td align="center">{{tr.all_price?tr.all_price.toFixed(2):'0.00'}}</td>
        </tr>
        <tr v-if="list.length > 0">
          <td align="center">合计</td>
          <td align="center"></td>
          <td align="center"></td>
          <td align="center"></td>
          <td align="center"></td>
          <td align="center"></td>
          <td align="center">{{sumsTotal.quantity}}</td>
          <td align="center">{{sumsTotal.price?sumsTotal.price.toFixed(2):'0.00'}}</td>
          <td align="center">{{sumsTotal.discount?sumsTotal.discount.toFixed(2):'0.00'}}</td>
          <td align="center">{{sumsTotal.tax?sumsTotal.tax.toFixed(2):'0.00'}}</td>
          <td align="center">{{sumsTotal.server_price?sumsTotal.server_price.toFixed(2):'0.00'}}</td>
          <td align="center">{{sumsTotal.discount_price?sumsTotal.discount_price.toFixed(2):'0.00'}}</td>
          <td align="center">{{sumsTotal.all_price?sumsTotal.all_price.toFixed(2):'0.00'}}</td>
        </tr>
      </tbody>
    </table>


  </div>
</template>
<script>
export default {
  props: {
    
    tabelList: {
      type: Array,
      default: []
    },
    sumsTotal: {
      type: Array,
      default: []
    },
    listQuery: {
      type: Object,
    },
    exportShow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    list() {
      return this.tabelList
    }
  },
  data() {
    return {
      employee: {},
      currentTime: '', //当前的时间
      hotelInfo: {},
      nameTitle: [
         {name:'营业点',key:'outletName'},
        {name:'菜谱名称',key:'bookName'},
        {name:'菜类编号',key:'typeCode'},
        {name:'菜类',key:'typeName'},
        {name:'菜品编码',key:'dishesCode'},
        {name:'名称',key:'food_name'},
        {name:'数量',key:'quantity'},
        {name:'单价',key:'price'},
        {name:'折扣',key:'discount'},
        {name:'税',key:'tax'},
        {name:'服务费',key:'server_price'},
        {name:'应收',key:'discount_price'},
        {name:'实收',key:'all_price'},
      ],
      sort: false,
    }
  },
  methods: {
    //排序
    handleSort(val) {
      if (this.sort) {
        if (typeof (this.list[0][val]) == 'number') {
          this.list.sort(function (a, b) {
            return a[val] - b[val]
          })
        } else {
          this.list.sort(
            function compareFunction(param1, param2) {
              return param1[val].localeCompare(param2[val], 'zh-Hans-CN', { sensitivity: 'accent' });
            }
          )
        }
        this.sort = false
      } else {
        if (typeof (this.list[0][val]) == 'number') {
          this.list.sort(function (a, b) {
            return b[val] - a[val]
          })
        } else {
          this.list.sort(
            function compareFunction(param1, param2) {
              return param2[val].localeCompare(param1[val], 'zh-Hans-CN', { sensitivity: 'accent' });
            }
          )
        }
        this.sort = true
      }
    },
  }

}
</script>
<style lang="scss" scoped>
.salesList {
  width: 100%;
  max-height: calc(100vh - 210px);
  padding: 20px 0;
  color: #666;
  overflow: auto;
  td {
    line-height: 66px;
    font-size: 24px;
  }
}
</style>